import {
  NgModule,
  InjectionToken,
  Injector,
  ModuleWithProviders,
} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  StoreModule,
  State,
  StateObservable,
  ActionsSubject,
  ScannedActionsSubject,
  ReducerObservable,
  ReducerManagerDispatcher,
  ActionReducerMap,
  ActionReducerFactory,
  INITIAL_STATE,
  INITIAL_REDUCERS,
  REDUCER_FACTORY,
} from '@ngrx/store';
import { StoreDevtools, DevtoolsDispatcher } from './devtools';
import {
  StoreDevtoolsConfig,
  StoreDevtoolsOptions,
  STORE_DEVTOOLS_CONFIG,
  INITIAL_OPTIONS,
} from './config';
import {
  DevtoolsExtension,
  REDUX_DEVTOOLS_EXTENSION,
  ReduxDevtoolsExtension,
} from './extension';

export const /** @type {?} */ IS_EXTENSION_OR_MONITOR_PRESENT = new InjectionToken<boolean>(
  'Is Devtools Extension or Monitor Present'
);
/**
 * @param {?} extension
 * @param {?} config
 * @return {?}
 */
export function createIsExtensionOrMonitorPresent(
  extension: ReduxDevtoolsExtension | null,
  config: StoreDevtoolsConfig
) {
  return Boolean(extension) || config.monitor !== noMonitor;
}
/**
 * @return {?}
 */
export function createReduxDevtoolsExtension() {
  const /** @type {?} */ extensionKey = '__REDUX_DEVTOOLS_EXTENSION__';

  if (
    typeof window === 'object' &&
    typeof ( /** @type {?} */((window as any)))[extensionKey] !== 'undefined'
  ) {
    return ( /** @type {?} */((window as any)))[extensionKey];
  } else {
    return null;
  }
}
/**
 * @param {?} devtools
 * @return {?}
 */
export function createStateObservable(devtools: StoreDevtools) {
  return devtools.state;
}
/**
 * @return {?}
 */
export function noMonitor(): null {
  return null;
}
/**
 * @param {?} _options
 * @return {?}
 */
export function createConfig(
  _options: StoreDevtoolsOptions
): StoreDevtoolsConfig {
  const /** @type {?} */ DEFAULT_OPTIONS: StoreDevtoolsConfig = {
    maxAge: false,
    monitor: noMonitor,
  };

  let /** @type {?} */ options = typeof _options === 'function' ? _options() : _options;
  const /** @type {?} */ config = Object.assign({}, DEFAULT_OPTIONS, options);

  if (config.maxAge && config.maxAge < 2) {
    throw new Error(
      `Devtools 'maxAge' cannot be less than 2, got ${config.maxAge}`
    );
  }

  return config;
}
export class StoreDevtoolsModule {
/**
 * @param {?=} options
 * @return {?}
 */
static instrument(options: StoreDevtoolsOptions = {}): ModuleWithProviders {
    return {
      ngModule: StoreDevtoolsModule,
      providers: [
        DevtoolsExtension,
        DevtoolsDispatcher,
        StoreDevtools,
        {
          provide: INITIAL_OPTIONS,
          useValue: options,
        },
        {
          provide: IS_EXTENSION_OR_MONITOR_PRESENT,
          deps: [REDUX_DEVTOOLS_EXTENSION, STORE_DEVTOOLS_CONFIG],
          useFactory: createIsExtensionOrMonitorPresent,
        },
        {
          provide: REDUX_DEVTOOLS_EXTENSION,
          useFactory: createReduxDevtoolsExtension,
        },
        {
          provide: STORE_DEVTOOLS_CONFIG,
          deps: [INITIAL_OPTIONS],
          useFactory: createConfig,
        },
        {
          provide: StateObservable,
          deps: [StoreDevtools],
          useFactory: createStateObservable,
        },
        {
          provide: ReducerManagerDispatcher,
          useExisting: DevtoolsDispatcher,
        },
      ],
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function StoreDevtoolsModule_tsickle_Closure_declarations() {
/** @type {?} */
StoreDevtoolsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StoreDevtoolsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../../modules/store-devtools/src/instrument.ts